/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faAddressBook,
    faAddressCard,
    faBook,
    faBookOpen,
    faCalendarDays,
    faChartLine,
    faCircleCheck,
    faCircleXmark,
    faCoins,
    faComputer,
    faDownload,
    faEllipsis,
    faEnvelope,
    faEyeSlash,
    faFileArrowUp,
    faFileExport,
    faFileLines,
    faFilePen,
    faFileWaveform,
    faFilter,
    faFloppyDisk,
    faFolderOpen,
    faGear,
    faHandHoldingDollar,
    faHouse,
    faKey,
    faLaptopCode,
    faLink,
    faLocationDot,
    faMicroscope,
    faMobileScreen,
    faNoteSticky,
    faPen,
    faPhone,
    faPlus,
    faPowerOff,
    faQuestion,
    faRadiation,
    faTag,
    faToolbox,
    faTrash,
    faUpload,
    faUser,
    faUsers,
    faUserTag,
    faVcard,
    faXmark,
    faEye, faCircleInfo, faFileCsv,
} from "@fortawesome/free-solid-svg-icons";
import {faFileExcel} from "@fortawesome/free-regular-svg-icons";

export type IconType = 'settings' | 'report' | 'logout' | 'home' | 'mail' | 'phone' | 'mobile' | 'persons' | 'customers' |
    'devices' | 'users' | 'models' | 'edit' | 'add' | 'delete' | 'save' | 'cancel' | 'more' | 'disable' |
    'filter' | 'address' | 'contact_ceo' | 'contact_invoice' | 'contact_it' | 'contact_radiation' | 'questionmark' |
    'notes' | 'exam' | 'event' | 'yes' | 'no' | 'software' | 'link' | 'coins' | 'calendar' | 'mpe' | 'groups' |
    'password' | 'upload' | 'history' | 'copy' | 'download' | 'manual_entry' | 'vCard' | 'upload-list' | 'mapping' |
    'columnmapping' | 'documentation'| 'visible' | 'invisible' | "info" | "circle-check" | "note"| "export"

interface IconsSetProps {
    type: IconType,
    style?: any,
    className?: string,
}

export function IconSet(props: IconsSetProps) {
    switch (props.type) {
        case "add":
            //return <PlusOutlined {...props}/>
            return <FontAwesomeIcon icon={faPlus} {...props}/>
        case "address":
            return <FontAwesomeIcon icon={faLocationDot} {...props}/>
        case "calendar":
            return <FontAwesomeIcon icon={faCalendarDays} {...props}/>
        case "cancel":
            //return <CloseOutlined {...props}/>
            return <FontAwesomeIcon icon={faXmark} {...props}/>
        case "coins":
            return <FontAwesomeIcon icon={faCoins} {...props}/>
        case "contact_ceo":
            return <FontAwesomeIcon icon={faAddressCard} {...props}/>
        case "contact_invoice":
            return <FontAwesomeIcon icon={faHandHoldingDollar} {...props}/>
        case "contact_it":
            return <FontAwesomeIcon icon={faComputer} {...props}/>
        case "contact_radiation":
            return <FontAwesomeIcon icon={faRadiation} {...props}/>
        case "copy":
            return <FontAwesomeIcon icon={faFileExport} {...props}/>
        case "columnmapping":
            return <FontAwesomeIcon icon={faBook} {...props}/>
        case "customers":
            //return <TeamOutlined {...props}/>
            return <FontAwesomeIcon icon={faUsers} {...props}/>
        case "delete":
            //return <DeleteOutlined {...props}/>
            return <FontAwesomeIcon icon={faTrash} {...props}/>
        case "devices":
            // return <TagsOutlined {...props}/>
            return <FontAwesomeIcon icon={faMicroscope} {...props}/>
        case "invisible":
        case "disable":
            //return <DisconnectOutlined {...props}/>
            return <FontAwesomeIcon icon={faEyeSlash} {...props}/>
        case "documentation":
            return <FontAwesomeIcon icon={faBookOpen} {...props}/>
        case "download":
            return <FontAwesomeIcon icon={faDownload} {...props}/>
        case "edit":
            //return <EditOutlined {...props}/>
            return <FontAwesomeIcon icon={faPen} {...props}/>
        case "event":
            return <FontAwesomeIcon icon={faFileWaveform} {...props}/>
        case "exam":
            return <FontAwesomeIcon icon={faFolderOpen} {...props}/>
        case "filter":
            //return <FilterOutlined {...props}/>
            return <FontAwesomeIcon icon={faFilter} {...props}/>
        case "groups":
            return <FontAwesomeIcon icon={faUserTag} {...props}/>
        case "history":
            return <FontAwesomeIcon icon={faChartLine} {...props}/>
        case "home":
            //return <HomeOutlined {...props}/>
            return <FontAwesomeIcon icon={faHouse} {...props}/>
        case "link":
            return <FontAwesomeIcon icon={faLink} {...props}/>
        case "logout":
            //return <PoweroffOutlined {...props}/>
            //return <FontAwesomeIcon icon={faRightFromBracket} {...props}/>
            return <FontAwesomeIcon icon={faPowerOff} {...props}/>
        case "mail":
            //return <MailOutlined {...props}/>
            return <FontAwesomeIcon icon={faEnvelope} {...props}/>
        case "manual_entry":
            return <FontAwesomeIcon icon={faFilePen} {...props}/>
        case "mapping":
            return <FontAwesomeIcon icon={faBook} {...props}/>
        case "mobile":
            //return <MobileOutlined {...props}/>
            return <FontAwesomeIcon icon={faMobileScreen} {...props}/>
        case "models":
            //return <ReadOutlined {...props}/>
            return <FontAwesomeIcon icon={faToolbox} {...props}/>
        case "more":
            //return <DashOutlined {...props}/>
            return <FontAwesomeIcon icon={faEllipsis} {...props}/>
        case "mpe":
            return <FontAwesomeIcon icon={faTag} {...props}/>
        case "no":
            return <FontAwesomeIcon icon={faCircleXmark} {...props}/>
        case "notes":
            return <FontAwesomeIcon icon={faNoteSticky} {...props}/>
        case "password":
            return <FontAwesomeIcon icon={faKey} {...props}/>
        case "persons":
            //return <ContactsOutlined {...props}/>
            return <FontAwesomeIcon icon={faAddressBook} {...props}/>
        case "phone":
            //return <PhoneOutlined {...props}/>
            return <FontAwesomeIcon icon={faPhone} {...props}/>
        case "report":
            return <FontAwesomeIcon icon={faFileLines} {...props}/>
        case "save":
            //return <SaveOutlined {...props}/>
            return <FontAwesomeIcon icon={faFloppyDisk} {...props}/>
        case "settings":
            //return <SettingOutlined {...props}/>
            return <FontAwesomeIcon icon={faGear} {...props}/>
        case "software":
            return <FontAwesomeIcon icon={faLaptopCode} {...props}/>
        case "upload":
            return <FontAwesomeIcon icon={faUpload} {...props}/>
        case "upload-list":
            return <FontAwesomeIcon icon={faFileArrowUp} {...props}/>
        case "users":
            //return <UserOutlined {...props}/>
            return <FontAwesomeIcon icon={faUser} {...props}/>
        case "vCard":
            return <FontAwesomeIcon icon={faVcard} {...props}/>
        case "yes":
            return <FontAwesomeIcon icon={faCircleCheck} {...props}/>
        case 'visible':
            return <FontAwesomeIcon icon={faEye} {...props}/>
        case "info":
            return <FontAwesomeIcon icon={faCircleInfo} {...props}/>
        case "circle-check":
            return <FontAwesomeIcon icon={faCircleCheck} {...props}/>
        case "note":
            return <FontAwesomeIcon icon={faNoteSticky} {...props}/>
        case "export":
            return <FontAwesomeIcon icon={faFileExcel} {...props}/>
        case "questionmark":
        default:
            //return <QuestionOutlined {...props}/>
            return <FontAwesomeIcon icon={faQuestion} {...props}/>
    }
}